<template>
  <div class="media-library-fi">
    <accordion-item-fi
      v-for="(mediaCategory, categoryIndex) in fields.mediaLibraryCategories"
      :key="categoryIndex"
      header-tag="div"
      class="media-library-fi__accordion"
      theme="media-library-category"
    >
      <template #header>
        {{ mediaCategory.fields.title.value }}
      </template>
      <template #content>
        <accordion-item-fi
          v-for="(mediaGroup, groupIndex) in mediaCategory.fields.mediaLibraryGroups"
          :key="groupIndex"
          header-tag="div"
          class="media-library-fi__accordion"
          theme="media-library-group-item"
        >
          <template #header>
            {{ mediaGroup.fields.title.value }}
          </template>
          <template #content>
            <div class="media-library-fi__items">
              <media-library-item-fi
                v-for="(mediaItem, itemIndex) in mediaGroup.fields.mediaLibraryItems"
                :key="itemIndex"
                :item="mediaItem"
              />
            </div>
          </template>
        </accordion-item-fi>
      </template>
    </accordion-item-fi>
  </div>
</template>

<script setup lang="ts">
import { AccordionItemFi } from 'atoms';

import setupAccordion from '@/components/atoms/accordion/setupAccordion';
import MediaLibraryItemFi from '@/components/media-library-item-fi/MediaLibraryItemFi.vue';
import { useFields } from '@/composables/fields';

const fields = useFields('MediaLibraryPageFiFields');
setupAccordion(true);
</script>

<style scoped src="./media-library-fi" />
